import React from "react";
import { getAppUrl } from "@webcore/config/appConfig.ts";
import DatafabriqLogo from "./DatafabriqLogo";
import ContentButton from "./ui/ContentButton";

export interface ContentNavLink {
  label: string;
  to: string;
}

interface ContentNavProps {
  navLinks?: ContentNavLink[];
  showSignInButtons?: boolean;
  signUpEnabled?: boolean;
}

const ContentNav: React.FC<ContentNavProps> = ({
  navLinks = [],
  showSignInButtons = true,
  signUpEnabled = false,
}) => {
  return (
    <nav className="cs-nav">
      <div className="cs-nav-inner">
        {/* CSS-only disclosure, not state: content-website's prerendered blog posts ship no JS. */}
        {navLinks.length > 0 && (
          <input type="checkbox" id="cs-nav-toggle" className="cs-nav-toggle-checkbox" />
        )}

        <DatafabriqLogo />

        {navLinks.length > 0 && (
          <div className="cs-nav-mid">
            {navLinks.map((link) => (
              <a key={link.to} href={link.to}>{link.label}</a>
            ))}
          </div>
        )}

        <div className="cs-nav-right">
          {navLinks.length > 0 && (
            <label className="cs-nav-toggle" htmlFor="cs-nav-toggle" aria-label="Toggle navigation">
              <span></span>
              <span></span>
              <span></span>
            </label>
          )}
          {showSignInButtons && (
            <>
              <ContentButton href={getAppUrl("/login/start")} variant="secondary">
                sign in
              </ContentButton>
              {signUpEnabled && (
                <ContentButton href="/book-a-demo" variant="primary">
                  book a demo →
                </ContentButton>
              )}
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default ContentNav;
